// extracted by mini-css-extract-plugin
export default {"Wrapper":"AnalyticsPage_Wrapper__YOP1N"};